import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessGuard } from '../air/modules/common/guards/access/access.guard';
import { AirAppRoutes } from './modules/common/lib/air-api-constant';
import { AirUserSettingsResolver } from './modules/common/resolver/air-user-settings.resolver';
import { AppMainComponent } from './modules/common/component';
//Author: Kalindi Tripathi
const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: AirAppRoutes.UserFull.HOME,
            },
            {
                path: AirAppRoutes.UserFull.HOME,
                loadChildren: () => import('./modules/user/home/home.module').then((m) => m.TntHomeModule),
            },
            {
                path: AirAppRoutes.UserFull.TRACKING_LIST,
                loadChildren: () => import('./modules/user/trackinglist/trackinglist.module').then((m) => m.TrackingListModule),
            },
            {
                path: AirAppRoutes.UserFull.TRACKING_LIST_DETAILS_HOME + ':shipmentid',
                loadChildren: () => import('./modules/user/trackingList-details/tnt-trackinglist-Details.module').then((m) => m.TntTrackingListDetialsModule),
            },
            {
                path: AirAppRoutes.UserFull.TRACKING_LIST_DETAILS + ':shipmentid',
                loadChildren: () => import('./modules/user/trackingList-details/tnt-trackinglist-Details.module').then((m) => m.TntTrackingListDetialsModule),
            },
            // {
            //     path: AirAppRoutes.UserFull.TRACKING_LIST_DETAILS_FAVORITE +':shipmentid',
            //     loadChildren: () => import('./modules/user/trackingList-details/tnt-trackinglist-Details.module').then((m) => m.TntTrackingListDetialsModule),
            // },
            {
                path: AirAppRoutes.UserFull.PROFILE,
                loadChildren: () => import('./modules/user/profile/profile.module').then(m => m.ProfileModule)
            },
            {
                path: AirAppRoutes.UserFull.ETA_THRESHOLD,
                loadChildren: () => import('./modules/user/eta-threshold/eta-threshold.module').then((m) => m.EtaThresholdModule),
            },
            {
                path: AirAppRoutes.UserFull.RELEASE_NOTES,
                loadChildren: () => import('./modules/user/upload-download/upload-download.module').then((m) => m.UploadDownloadModule),
            },
        
            // {
            //     path: AirAppRoutes.Manager.EXCEPTION,
            //     canActivate: [AccessGuard],
            //     loadChildren: () => import('./modules/manager/exception-manager/exceptionManager.module').then(m => m.ExceptionModule)
            // },

            {
                path: AirAppRoutes.Manager.EVENTS,
                canActivate: [AccessGuard],
                loadChildren: () => import('./modules/manager/events-management/events-management.module').then(m => m.EventsManagementModule)
            },
            {
                path: AirAppRoutes.UserFull.FLIGHT_EQUIVALENCY_MANAGER,
                canActivate: [AccessGuard],
                loadChildren: () => import('./modules/user/master-data-manager/master-data-manager.module').then((m) => m.MasterDataManagerModule),
            },
        ],
        resolve: {
            UserSettings: AirUserSettingsResolver,
        },
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AirRoutingModule { }
